import { search } from "@/service/post";
const state = {
  searchData: null,
};

const mutations = {
  SEARCH_DATA: (state, data) => {
    state.searchData = data;
  },
};

const actions = {
  getSearchData({ commit }, q) {
    return new Promise((resolve, reject) => {
      search(q)
        .then((response) => {
          const { data } = response;
          commit("SEARCH_DATA", data.list);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
